module.exports = __webpack_public_path__ + "public/1.0.1_009961/img/pass.f419c2e5.png";